export const blockIconsHomeNestClockFarsightAnalogNew = (
	<span className='material-symbols-outlined'>nest_clock_farsight_analog</span>
);
